// extracted by mini-css-extract-plugin
export default {"main":"successWithdrawalModal_main__bdQHn","heading":"successWithdrawalModal_heading__Fde3K","confirmation":"successWithdrawalModal_confirmation__fUzmA"};